<template>
  <div class="auth-layout min-h-screen flex items-center justify-center relative overflow-hidden">
    <!-- Djust Dark Background -->
    <div class="absolute inset-0" style="background: linear-gradient(135deg, #000d1a 0%, #001a33 30%, #003467 70%, #1c4fd9 100%);" />

    <!-- Glowing effects -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute -top-40 -right-40 w-96 h-96 bg-[#3171ff]/15 rounded-full blur-3xl" />
      <div class="absolute -bottom-40 -left-40 w-96 h-96 bg-[#a79ae0]/10 rounded-full blur-3xl" />
      <div class="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#9ad2ff]/5 rounded-full blur-3xl" />
    </div>

    <!-- Content Card -->
    <div class="relative z-10 w-full max-w-md mx-4">
      <div class="backdrop-blur-xl bg-white/5 border border-[rgba(154,210,255,0.12)] shadow-2xl rounded-2xl p-8">
        <slot />
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-center space-x-3 mt-6">
        <p class="text-blue-300/60 text-xs">
          © {{ new Date().getFullYear() }} DJUST. All rights reserved.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'AuthLayout',
});
</script>
